import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, renderList as _renderList, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "task-parameters-table_item is-header border-bottom" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = {
  key: 0,
  class: "task-parameters-table_item_name"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "task-parameters-table_item_divider" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "task-parameters-table_item_divider" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "task-parameters-table_item_buttons" }, "Действия", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "task-parameters-table_item_divider" }, null, -1)
const _hoisted_9 = { class: "task-parameters-table_item_default" }
const _hoisted_10 = { class: "task-parameters-table_list" }
const _hoisted_11 = ["onMousemove"]
const _hoisted_12 = { class: "task-parameters-table_item_parameter" }
const _hoisted_13 = {
  key: 0,
  class: "task-parameters-table_item_name"
}
const _hoisted_14 = { class: "task-parameters-table_item_description_buttons" }
const _hoisted_15 = ["textContent"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "task-parameters-table_item_buttons" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "task-parameters-table_item_buttons_wrapper" }, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "task-parameters-table_item_buttons_wrapper"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "task-parameters-table_item_default" }

import { TaskParameterModel, TaskParameterTypeEnum, TaskParameter } from "@/components";
import { computed, onBeforeMount, PropType, ref, watch } from "vue";
import {
  TirPmRadio,
  TirPmScrollbar,
  TirPmDraggableSorting,
  DragModel,
  TirPmOptionListItemElement,
  TirPmInput,
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
} from "tir-components";
import {
  TrashIcon,
  PencilSquareIcon,
  CrossCompactIcon,
  CheckIcon,
} from "tir-style-system/icons/outline";
import { TaskStatusDropdownNew } from "@/components/task-forms/components";
import { StatusModel } from "@/components/task-forms/models";
import { TaskStatusesServiceAdapter } from "../adapter-service";
import TirPmGlobalStatus from "./TirPmGlobalStatus.vue";
import { ParameterRemoveModal } from "./";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-parameters-table',
  props: {
  /**Список параметров */
  parameters: {
    type: Array as PropType<TaskParameterModel>,
    default: () => [] as TaskParameterModel[],
  },
  /**Тип настройки */
  type: { type: Number as PropType<TaskParameterTypeEnum> },
  /**Заголовок параметра */
  title: { type: String, default: "" },
  /**Имя области */
  namespaceName: { type: String },
},
  emits: ["remove"],
  setup(__props, { emit }) {

const props = __props;


/**События */


const adapter = new TaskStatusesServiceAdapter();
/**Стандартный параметр */
const defaultParameterIndex = ref<number | string>();
/**Индекс наведенного элемента */
const hoverIndex = ref<number>();
/**Сфокусирован ли какой то параметр */
const isFocus = ref();
const isOpened = ref(false);
const statuses = ref([]);
/**Окно для подтверждения удаления параметра */
const $parameterRemoveModal = ref<InstanceType<typeof ParameterRemoveModal>>();
/**Сфокусированный параметр */
const focusedParameter = ref<string | number>();
/**Элемент таблицы */
const $table = ref<HTMLElement>();
/**Вводимое описание */
const description = ref("");

/**Параметр рабочей области */
const isNamespaceParameter = computed(
  () => props.type == TaskParameterTypeEnum.Type || props.type == TaskParameterTypeEnum.Difficulty,
);
/**Базовый параметр */
const basicParameter = computed(() => props.parameters.find((p) => p.IsDefault));
/**Показывать ли настройку глобального статуса */
const showGlobalStatus = computed(() => props.type == TaskParameterTypeEnum.Status);
/**Перетаскиваемые параметры */
const dragParameters = computed(() =>
  props.parameters.map(
    (x) =>
      new DragModel({
        AllowDrag: true,
        AllowDrop: true,
        Data: x,
      }),
  ),
);
/**Показывать ли поле ввода описания */
const showDescription = computed(() => {
  return (
    props.type == TaskParameterTypeEnum.Type ||
    props.type == TaskParameterTypeEnum.Status ||
    props.type == TaskParameterTypeEnum.Tag
  );
});
/**Имя параметра */
const parameterName = computed(() => {
  switch (props.type) {
    case TaskParameterTypeEnum.Status:
      return "Статус";
    case TaskParameterTypeEnum.Priority:
      return "Приоритет";
    case TaskParameterTypeEnum.Tag:
      return "Тег";
    case TaskParameterTypeEnum.Type:
      return "Тип";
    case TaskParameterTypeEnum.Difficulty:
      return "Сложность";
  }
});

/**Отслеживание изменений параметров */
watch(() => props.parameters, onUpdateParameters, { deep: true });

/**Перед рендером */
onBeforeMount(async () => {
  onUpdateParameters();
  await getStatuses();
});

/**При изменении параметров */
function onUpdateParameters() {
  const defaultParameter = props.parameters.findIndex((x) => x.IsDefault);
  defaultParameterIndex.value = defaultParameter;
}
/**Смена стандартного параметра */
const changeDefault = (_index: number) => {
  props.parameters.forEach((x, index) => (x.IsDefault = index == _index));
};
/**Получение класса элемента */
const getItemClass = (index: number) => {
  return { hover: hoverIndex.value == index };
};
/**Установка значения поля hoverIndex */
const setHoverIndex = (index?: number) => {
  if (!isFocus.value) hoverIndex.value = index;
};
const isOpenedCustomItem = ref(false);
/**Удалить параметр */
const removeParameter = (name: string) => {
  const removeIndex = props.parameters.findIndex((x) => x.Name == name);
  if (removeIndex != -1) {
    setTimeout(() => {
      hoverIndex.value = undefined;
      props.parameters.splice(removeIndex, 1);
      if (!props?.parameters || props?.parameters?.length == 0) {
        return;
      }
      if (props.parameters.reduce((acc, x) => acc + (x.IsDefault ? 1 : 0), 0) == 0) {
        props.parameters[0].IsDefault = true;
      }
    });
  }
};

/**Обновить сортировку параметров */
const sortParameters = (_parameters: DragModel<TaskParameterModel>[]) => {
  props.parameters.splice(0, props.parameters.length);
  props.parameters.push(..._parameters.map((x) => x.Data));
};

async function getStatuses() {
  const res = await adapter.getGlobalStatusList();
  statuses.value = res.Value.map(
    (x) =>
      new StatusModel({ Color: x.Color, Id: x.Id as any, Name: x.Name, IsDefault: x.IsDefault }),
  );
}
const selGlobalItem = ref();
function onChangeStatus(item: StatusModel, slot: TaskParameterModel) {
  slot.OrganizationGlobalStatus = new TaskParameterModel({
    Id: item.Id,
    Name: item.Name,
    Color: item.Color,
  });
  selGlobalItem.value = item;
  isOpenedCustomItem.value = null;
  isOpened.value = false;
}
function onIsOpened(value: any) {
  isOpenedCustomItem.value = value;
}
/**Клик по кнопке удаления */
const onClickRemove = (parameter: TaskParameterModel) => {
  if (parameter.InUse && isNamespaceParameter.value) {
    $parameterRemoveModal.value?.open(parameter, basicParameter.value);
  } else {
    removeParameter(parameter.Name);
  }
};
/**Проверка возможности удаления */
const checkAllowRemove = (parameter: TaskParameterModel) => {
  return (
    !parameter.IsDefault &&
    props.parameters.length > 1 &&
    (!parameter.InUse || isNamespaceParameter.value)
  );
};
/**Проверка отображения поля ввода описания */
const checkShowDescriptionInput = (parameter: TaskParameterModel) => {
  return parameter.Id && focusedParameter.value == parameter.Id;
};
/**Старт добавления описания */
const addDescription = (parameter: TaskParameterModel) => {
  description.value = parameter.Description;
  focusedParameter.value = parameter.Id;
  const parameterIndex = props.parameters.findIndex((p) => p.Id == parameter.Id);
  const inputs = $table.value?.querySelectorAll(".task-parameters-table_item_description_input");

  const input = inputs?.[parameterIndex]?.querySelector(
    ".input-container__input",
  ) as HTMLInputElement;
  if (input) setTimeout(() => input.click());
};
/**Сброс фокуса с поля ввода описания */
const blurDescription = () => {
  focusedParameter.value = undefined;
  description.value = "";
};
/**Подтверждения изменения описания */
const confirmDescription = (parameter: TaskParameterModel) => {
  parameter.Description = description.value;
  setTimeout(() => blurDescription());
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "task-parameters-table",
      ref_key: "$table",
      ref: $table
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          textContent: _toDisplayString(parameterName.value),
          class: "task-parameters-table_item_parameter"
        }, null, 8, _hoisted_2),
        _createElementVNode("div", {
          class: _normalizeClass(["task-parameters-table_item_divider", { hidden: !showGlobalStatus.value }])
        }, null, 2),
        (!showDescription.value || showGlobalStatus.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (showGlobalStatus.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Глобальные статусы"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _hoisted_5,
        (showDescription.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", {
                class: _normalizeClass(["task-parameters-table_item_description", { 'with-status': showGlobalStatus.value }])
              }, " Описание ", 2),
              _hoisted_6
            ], 64))
          : _createCommentVNode("", true),
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, _toDisplayString(__props.title) + " по умолчанию", 1)
      ]),
      _createVNode(_unref(TirPmScrollbar), { "show-on-hover": "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_unref(TirPmDraggableSorting), {
              "is-allow-click-delay": "",
              dataClass: "task-parameters-table_drag-item",
              data: dragParameters.value,
              indent: 0,
              onChange: sortParameters
            }, {
              item: _withCtx((slot) => [
                (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["task-parameters-table_item", getItemClass(slot.index)]),
                  key: slot.item.Id || slot.item.TempId,
                  onMousemove: ($event: any) => (setHoverIndex(slot.index)),
                  onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (setHoverIndex(undefined)))
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_unref(TaskParameter), {
                      data: slot.item,
                      type: __props.type,
                      "hide-remove": ""
                    }, null, 8, ["data", "type"])
                  ]),
                  (!showDescription.value || showGlobalStatus.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (
                  showGlobalStatus.value &&
                  ((hoverIndex.value == slot.index && !isOpenedCustomItem.value) ||
                    isOpenedCustomItem.value == slot.item ||
                    (slot.item.OrganizationGlobalStatus && hoverIndex.value != slot.index))
                )
                          ? (_openBlock(), _createBlock(_unref(TaskStatusDropdownNew), {
                              key: 0,
                              onIsOpened: ($event: any) => (onIsOpened(slot.item)),
                              isOpened: isOpened.value,
                              selected: slot.item.OrganizationGlobalStatus
                            }, {
                              content: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statuses.value, (item, idx) => {
                                  return (_openBlock(), _createBlock(_unref(TirPmOptionListItemElement), {
                                    "is-hoverable": "",
                                    onClick: ($event: any) => (onChangeStatus(item, slot.item)),
                                    key: idx
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(TirPmRadio), {
                                        modelValue: defaultParameterIndex.value,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((defaultParameterIndex).value = $event)),
                                        value: ((slot?.item?.OrganizationGlobalStatus?.Id==item?.Id) && !!slot?.item?.OrganizationGlobalStatus?.Id) as any
                                      }, null, 8, ["modelValue", "value"]),
                                      _createVNode(TirPmGlobalStatus, { value: item }, null, 8, ["value"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["onIsOpened", "isOpened", "selected"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (showDescription.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["task-parameters-table_item_description", { 'with-status': showGlobalStatus.value }])
                      }, [
                        _withDirectives(_createElementVNode("div", null, [
                          _createVNode(_unref(TirPmInput), {
                            modelValue: description.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
                            "is-micro": "",
                            class: "task-parameters-table_item_description_input",
                            "is-with-hint": false,
                            onEnter: ($event: any) => (confirmDescription(slot.item)),
                            onBlur: blurDescription
                          }, null, 8, ["modelValue", "onEnter"]),
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_unref(CheckIcon), {
                              onMousedown: ($event: any) => (confirmDescription(slot.item))
                            }, null, 8, ["onMousedown"]),
                            _createVNode(_unref(CrossCompactIcon), { onMousedown: blurDescription })
                          ])
                        ], 512), [
                          [_vShow, checkShowDescriptionInput(slot.item)]
                        ]),
                        (slot.item.Description && focusedParameter.value != slot.item.Id)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              textContent: _toDisplayString(slot.item.Description),
                              class: "task-parameters-table_item_description_text"
                            }, null, 8, _hoisted_15))
                          : _createCommentVNode("", true),
                        _withDirectives(_createVNode(_unref(TirPmButton), {
                          modelValue: description.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((description).value = $event)),
                          class: _normalizeClass(["task-parameters-table_item_description_button", { 'with-description': !!slot.item.Description }]),
                          variant: _unref(TirPmButtonVariantEnum).LinkState,
                          size: _unref(TirPmButtonSizeEnum).Small,
                          onClick: ($event: any) => (addDescription(slot.item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(PencilSquareIcon), { class: "task-parameters-table_item_description_icon" }),
                            (!slot.item.Description)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Добавить описание"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "class", "variant", "size", "onClick"]), [
                          [_vShow, focusedParameter.value != slot.item.Id]
                        ])
                      ], 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    (hoverIndex.value == slot.index)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          (checkAllowRemove(slot.item))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "task-parameters-table_item_icon",
                                onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                                onClick: ($event: any) => (onClickRemove(slot.item))
                              }, [
                                _createVNode(_unref(TrashIcon))
                              ], 40, _hoisted_20))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_unref(TirPmRadio), {
                      modelValue: defaultParameterIndex.value,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => ((defaultParameterIndex).value = $event)),
                        ($event: any) => (changeDefault(slot.index))
                      ],
                      value: slot.index
                    }, null, 8, ["modelValue", "value", "onUpdate:modelValue"])
                  ])
                ], 42, _hoisted_11))
              ]),
              _: 1
            }, 8, ["data"])
          ])
        ]),
        _: 1
      })
    ], 512),
    _createVNode(_unref(ParameterRemoveModal), {
      ref_key: "$parameterRemoveModal",
      ref: $parameterRemoveModal,
      namespaceName: __props.namespaceName,
      onRemove: removeParameter
    }, null, 8, ["namespaceName"])
  ], 64))
}
}

})